/**
 * Design Tokens
 * 
 * Based on the "perfect" Salary Management style.
 * These variables serve as the single source of truth for the entire app.
 */

export const designTokens = {
    colors: {
        primary: "#1890ff", // Reverted to classic AntD Blue
        secondary: "#722ed1", // Reverted to classic AntD Purple
        success: "#52c41a", // Emerald-500
        warning: "#faad14", // Amber-500
        error: "#f5222d", // Rose-500

        background: {
            light: "#F1F5F9", // Slate-100 (airy background)
            dark: "#000000",   // True black as seen in Salary Management
        },

        card: {
            light: "#FFFFFF",
            dark: "#000000", // Cards in salary management blend with black or have subtle borders
        },

        text: {
            light: "#0f172a", // Slate-900
            dark: "#f1f5f9",  // Slate-100
            secondary: "#64748b", // Slate-500
        },

        border: {
            light: "#e2e8f0", // Slate-200
            dark: "#1e293b",  // Slate-800
        }
    },

    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontSizeBase: 14, // Enterprise standard base font size
        fontSize: {
            xs: "11px",   // Badges / compact tags (upgraded from 9px)
            sm: "12px",   // Secondary labels / captions (upgraded from 11px)
            base: "14px", // Standard body text & form controls (upgraded from 13px)
            md: "15px",   // Elevated body / table cells
            lg: "16px",   // Subheadings / card headers
            xl: "18px",   // Section headers / modal titles
            "2xl": "22px", // Page Titles
            "3xl": "26px", // Display titles
        },
        fontWeight: {
            normal: "400",
            medium: "500",
            semibold: "600",
            bold: "700",
            black: "800",
        }
    },

    spacing: {
        radius: "12px", // Consistent rounded corners
    },

    shadows: {
        sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    }
};
